import { ReactNode } from 'react'

const IndentedList = ({
  children,
  listStyle = 'list-disc',
}: {
  children: ReactNode
  listStyle?: 'list-disc' | 'list-circle'
}): JSX.Element => {
  return <ul className={`pl-8 ${listStyle}`}>{children}</ul>
}

export default IndentedList
